import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
	display: table;
	width: 100%;
	position: relative;
`;

const Inner = styled.div`
	max-width: 75rem;
	margin: 0 auto;
`;

export default ({ children }) => (
	<Wrap>
		<Inner>{children}</Inner>
	</Wrap>
);
